export default __webpack_public_path__ + "static/media/logo_customerio.0a13ce84.svg";